/**
 * Value Estimator — settings page.
 *
 * Route: /prioritization/settings/value-estimator-agent
 *
 * The first agent on the template (SPEC-custom-agent-template.md). Its page is
 * the template's common settings page with the estimate_value panel; custom
 * agents made on the same behavior get the same page.
 */

import { TemplateAgentSettings } from '../../../components/agents/TemplateAgentSettings';
import { VALUE_ESTIMATOR } from '../../../lib/ai/agentDefinitions';

export default function ValueEstimatorAgent() {
  return <TemplateAgentSettings def={VALUE_ESTIMATOR} />;
}
